export default "__VITE_ASSET__B8130Q_z__"